<template>
  <AppDataTable design="new" density="dense" :columns="columns" :rows="rows" row-key="key" min-width="1200px" clickable :is-row-expanded="isExpanded" @row-click="toggle($event.row.key)">
    <template #cell-event="{ row }"><div class="ui-actions ui-actions--tight"><AppIconButton :label="expandedKey === row.key ? 'Collapse event' : 'Expand event'" @click="toggle(row.key)"><i :class="expandedKey === row.key ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" aria-hidden="true" /></AppIconButton><AppTableText :text="row.label" /></div></template>
    <template #cell-occurred="{ row }"><AppTableText :text="dateTime(row.occurred_at)" /></template>
    <template #cell-actor="{ row }"><AppTableUser :name="row.actor ? display(row.actor) : ''" /></template>
    <template #cell-kind="{ row }"><AppTableText :text="kindLabel(row.kind)" /></template>
    <template #cell-action="{ row }"><AppTableText :text="display(row.action_id)" /></template>
    <template #cell-delivery="{ row }"><AppTableText :text="display(row.delivery_id)" /></template>
    <template #row-detail="{ row: item }">
              <div class="automation-history-detail-grid">
                <DetailCard new-ui title="Record source">
                  <Fields :fields="sourceFields(item)" />
                </DetailCard>
                <DetailCard new-ui title="Recorded details">
                  <pre v-if="hasDetails(item.details)" class="automation-history-json">{{ detailsText(item.details) }}</pre>
                  <p v-else class="automation-muted automation-history-empty">
                    No additional details were recorded for this event.
                  </p>
                </DetailCard>
              </div>
    </template>
  </AppDataTable>
</template>
<script>
import { display, dateTime } from './model'
import DetailCard from './DetailCard.vue'
import Fields from './Fields.vue'
import AppTableText from '@/components/AppTableText.vue'
import AppTableUser from '@/components/AppTableUser.vue'

export default {
  name: 'FollowUpAutomationHistoryTable',
  components: { DetailCard, Fields, AppTableText, AppTableUser },
  props: { rows: { type: Array, required: true } },
  data: () => ({ expandedKey: null, columns: [{ key: 'event', label: 'Event', width: '250px' }, { key: 'occurred', label: 'Occurred', width: '170px' }, { key: 'actor', label: 'Actor', width: '180px' }, { key: 'kind', label: 'Kind', width: '130px' }, { key: 'action', label: 'Action', width: '120px' }, { key: 'delivery', label: 'Delivery', width: '120px' }] }),
  methods: {
    display,
    dateTime,
    isExpanded(item) { return this.expandedKey === item.key },
    toggle(key) {
      this.expandedKey = this.expandedKey === key ? null : key
    },
    kindLabel(kind) {
      return {
        run: 'Run',
        action: 'Action',
        delivery: 'Delivery',
        flow_event: 'Flow event'
      }[kind] || display(kind)
    },
    sourceFields(item) {
      return [
        ['Model', item.source && item.source.model],
        ['Record ID', item.source && item.source.id],
        ['Action ID', item.action_id],
        ['Delivery ID', item.delivery_id]
      ].filter(([, value]) => value !== null && value !== undefined && value !== '')
    },
    hasDetails(details) {
      return details && Object.keys(details).length > 0
    },
    detailsText(details) {
      return JSON.stringify(details, null, 2)
    }
  }
}
</script>

<style scoped lang="scss">
.automation-history-table {
  min-width: 900px;
}
.automation-history-row > td:first-child {
  min-width: 260px;
  white-space: nowrap;
}
.automation-history-row:focus-visible {
  outline: 2px solid $ui-blue;
  outline-offset: -2px;
}
.automation-attempt-chevron {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin-right: $ui-space-8;
  vertical-align: middle;
  transform: rotate(-90deg);
  transition: transform .2s ease;
}
.automation-attempt-chevron--open {
  transform: rotate(0);
}
.automation-attempt-chevron img {
  width: 10px;
  height: 6px;
}
.automation-history-detail-cell {
  padding: $ui-space-16 !important;
  background: $ui-surface-soft;
  white-space: normal !important;
}
.automation-history-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: $ui-space-12;
}
.automation-history-detail-grid > .automation-detail-card {
  height: 100%;
}
.automation-history-json {
  max-height: 320px;
  margin: 0;
  overflow: auto;
  padding: $ui-space-16;
  border: 1px solid $ui-line;
  border-radius: $ui-panel-radius;
  background: $ui-surface-soft;
  font: inherit;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.automation-history-empty {
  margin: 0;
}
@media (max-width: 760px) {
  .automation-history-detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
